import { Badge } from "@mantine/core";
import { i18n } from "@dehub/theme";
import { useTranslation } from "react-i18next";
import { ReturnReason } from "../../../apis/return";

export function reasonLabel (reason?: string | null): string {
  if (!reason) return "";
  return i18n.t(`returns:reason.${reason}`, { defaultValue: reason });
}

interface Props {
  reason: ReturnReason;
}

export function ReasonBadge ({ reason }: Props){
  const { t } = useTranslation("returns");
  return (
    <Badge color="gray" variant="light" size="lg" radius="xl" tt="none" fw={600} c="var(--nw-text)">
      {t(`reason.${reason}`)}
    </Badge>
  );
}
